"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { cn } from "@/lib/utils";
interface HeroCarouselProps {
  children: React.ReactNode[];
}
export function HeroCarousel(t0) {
  const $ = _c(11);
  const {
    children
  } = t0;
  const [api, setApi] = React.useState();
  const [current, setCurrent] = React.useState(0);
  let t1;
  let t2;
  if ($[0] !== api) {
    t1 = () => {
      if (!api) {
        return;
      }
      setCurrent(api.selectedScrollSnap());
      api.on("select", () => {
        setCurrent(api.selectedScrollSnap());
      });
    };
    t2 = [api];
    $[0] = api;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  React.useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      align: "center",
      containScroll: false,
      loop: false
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== current) {
    let t5;
    if ($[7] !== current) {
      t5 = (child, index) => <CarouselItem key={index} className={cn("basis-[95%] md:basis-[75%] lg:basis-[65%] max-w-6xl pl-0 transition-opacity duration-500 ease-in-out", current === index ? "opacity-100" : "opacity-30")}>{child}</CarouselItem>;
      $[7] = current;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = React.Children.map(children, t5);
    $[4] = children;
    $[5] = current;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <Carousel setApi={setApi} opts={t3} className="w-full"><CarouselContent className="gap-4 ml-0">{t4}</CarouselContent></Carousel>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}